import React, { useRef } from 'react';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollLogoSection } from './ScrollLogoSection';
import { Footer } from './Footer';
import ScrollBaseAnimation from './ui/scroll-text-marque';

gsap.registerPlugin(ScrollTrigger);

export const HorizontalScrollFooter = () => {
  const containerRef = useRef(null);
  const trackRef = useRef(null);

  useGSAP(() => {
    let mm = gsap.matchMedia();

    mm.add("(min-width: 768px)", () => {
      // Exactly one viewport width to scroll from panel 1 → panel 2
      const scrollDistance = window.innerWidth;

      gsap.to(trackRef.current, {
        x: -scrollDistance,
        ease: 'none',
        scrollTrigger: {
          trigger: containerRef.current,
          start: 'top top',
          end: () => `+=${scrollDistance}`,
          pin: true,
          scrub: 1,
          invalidateOnRefresh: true,
        },
      });
    });

  }, { scope: containerRef });

  return (
    <div ref={containerRef} className="w-full overflow-hidden bg-slate-50 dark:bg-[#030B1A] relative">
      <div ref={trackRef} className="flex flex-col md:flex-row md:h-screen md:w-[200vw]">
        {/* Panel 1: Logo */}
        <div className="w-full md:w-screen md:h-screen flex-shrink-0 relative">
          <ScrollLogoSection />
        </div>
        {/* Panel 2: Footer — must fill the full viewport height */}
        <div className="w-full md:w-screen md:h-screen flex-shrink-0 flex flex-col justify-center bg-slate-50 dark:bg-[#030B1A]">
          <Footer />
        </div>
      </div>

      {/* Persistent overlay Marquee overlapping both Logo and Footer parts */}
      <div className="absolute top-1/2 left-0 w-full z-50 opacity-[0.06] dark:opacity-[0.08] pointer-events-none -translate-y-1/2 mt-32 hidden md:block">
        <ScrollBaseAnimation
          baseVelocity={-2}
          scrollDependent={true}
          clasname="text-[12vw] font-black tracking-[-0.05em] uppercase text-slate-900 dark:text-white"
        >
          MARKETING EM MOVIMENTO &bull;
        </ScrollBaseAnimation>
      </div>
    </div>
  );
};
